import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

import Typography from "@mui/material/Typography";

import ImagePopupCta, {
  PopupTitle,
} from "@app/analytics/account/components/ImagePopupCta";
import PopupFooter from "@app/analytics/account/components/ImagePopupCta/PopupFooter";
import freeTrialActivatedBanner from "@app/analytics/assets/freeTrialActivatedBanner.png";
import * as Events from "@app/analytics/tracking/events";
import ProductFeatureList from "@app/common/components/ProductFeatureList";
import ProductFeatureListItem from "@app/common/components/ProductFeatureListItem";
import LINKS from "@app/common/links";
import ROUTES from "@app/common/routes";
import Config from "@app/config";

const FreeTrialActivatedModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [queryParams] = useSearchParams();

  const popupParam = queryParams.get("popup");
  const showModal = popupParam === "freeTrialActivated";

  const handleClose = () => {
    queryParams.delete("popup");
    navigate({ pathname: location.pathname, search: queryParams.toString() });
  };

  const handleSkip = () => {
    Events.activatedFreeTrial({ action: "skip_for_now" });
    handleClose();
  };

  const handleConfirm = () => {
    Events.activatedFreeTrial({ action: "new_workspace" });
    navigate(ROUTES.NEW_WORKSPACE);
  };

  return (
    <ImagePopupCta
      open={showModal}
      imageSrc={freeTrialActivatedBanner}
      onClose={handleClose}
    >
      <PopupTitle>
        Hooray! You've unlocked a {Config.billing.trialDays}-day free trial of
        Read Enterprise.
      </PopupTitle>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "1rem",
          lineHeight: "20px",
          color: "shades.neutral.700",
          mb: 1,
        }}
      >
        You now have access to:
      </Typography>
      <ProductFeatureList sx={{ mb: 2 }}>
        <ProductFeatureListItem linkTo={ROUTES.NEW_WORKSPACE}>
          Workspaces
        </ProductFeatureListItem>
        <ProductFeatureListItem href={LINKS.MARKETING.TRANSCRIPTION}>
          Meeting playback + transcription
        </ProductFeatureListItem>
        <ProductFeatureListItem linkTo={ROUTES.MEETING_REPORTS}>
          Advanced Reporting
        </ProductFeatureListItem>
        <ProductFeatureListItem linkTo={ROUTES.MEETING_REPORTS}>
          Participant-level metrics
        </ProductFeatureListItem>
        <ProductFeatureListItem>Benchmarks</ProductFeatureListItem>
        <ProductFeatureListItem linkTo={ROUTES.USER_SETTINGS_JOIN_PREFERENCES}>
          Unlimited meetings
        </ProductFeatureListItem>
      </ProductFeatureList>
      <PopupFooter
        justifyContent="flex-end"
        confirmText="Start with Workspaces"
        cancelText="Skip for now"
        onConfirm={handleConfirm}
        onCancel={handleSkip}
      />
    </ImagePopupCta>
  );
};

export default FreeTrialActivatedModal;
